import {
  PageConfig,
  PageConfigSchemaVersion,
} from "../../config/pageConfig.types";
import { DefaultFormId } from "../../config/resolveView";
import { fullWidth, halfWidth } from "../../blocks/layout/columnSpans";
import {
  AccessLevelOptions,
  IncludeChannelPreferencesOptions,
} from "../warehouseApplications/warehouseApplications";

/** A system's access to the Warehouse API: its credentials, then what it may do. */
export const warehouseApplicationPageConfig: PageConfig = {
  schemaVersion: PageConfigSchemaVersion,
  entityName: "WarehouseApplication",
  viewId: DefaultFormId,
  pageType: "record",
  rows: [
    {
      id: "row-main",
      columns: [
        {
          id: "column-primary",
          span: { desktop: 9, tablet: 12, mobile: 12 },
          card: true,
          fillHeight: true,
          blocks: [
            {
              kind: "section",
              id: "section-application",
              title: "Application",
              fields: [
                {
                  id: "field-write-only-notice",
                  type: "component",
                  name: "writeOnlyNotice",
                  label: "",
                  componentKey: "warehouseWriteOnlyNotice",
                  componentProps: { secret: "The client secret" },
                  span: fullWidth,
                },
                {
                  id: "field-ClientId",
                  type: "text",
                  name: "ClientId",
                  label: "Client ID",
                  required: true,
                  isNameField: true,
                  // Its own row, so Client Secret and Source pair up beneath it.
                  span: fullWidth,
                  // Fixed once created: the connected system signs in with it.
                  visibleWhen: "warehouseApplicationIsNew",
                },
                {
                  id: "field-ClientSecret",
                  type: "text",
                  name: "ClientSecret",
                  label: "Client Secret",
                  validatorKey: "warehouseClientSecret",
                  span: halfWidth,
                },
                {
                  id: "field-Source",
                  type: "text",
                  name: "Source",
                  label: "Source",
                  span: halfWidth,
                },
                {
                  id: "content-secret-set",
                  kind: "content",
                  type: "text",
                  content:
                    "Current status: value set. Leaving Client Secret blank preserves the existing stored value.",
                  span: fullWidth,
                  visibleWhen: "warehouseApplicationSecretSet",
                },
                {
                  id: "content-secret-not-set",
                  kind: "content",
                  type: "text",
                  content:
                    "Current status: not set. Leaving Client Secret blank preserves the existing stored value.",
                  span: fullWidth,
                  visibleWhen: "warehouseApplicationSecretNotSet",
                },
                {
                  id: "field-MatchKeySet",
                  type: "text",
                  name: "MatchKeySet",
                  label: "Match Key Set",
                  helpText:
                    "Enter a comma-separated list of match key ids. Leave empty to use all configured match keys.",
                  validatorKey: "warehouseMatchKeySet",
                  span: fullWidth,
                },
              ],
            },
          ],
        },
        {
          id: "column-secondary",
          span: { desktop: 3, tablet: 12, mobile: 12 },
          card: true,
          fillHeight: true,
          blocks: [
            {
              kind: "section",
              id: "section-access",
              title: "Access",
              fields: [
                {
                  id: "field-AccessLevel",
                  type: "radio",
                  name: "AccessLevel",
                  label: "Access Level",
                  options: AccessLevelOptions.map((option) => ({
                    ...option,
                    label: `${option.value} - ${option.label}`,
                  })),
                  span: fullWidth,
                },
                {
                  id: "field-IncludeChannelPreferences",
                  type: "radio",
                  name: "IncludeChannelPreferences",
                  label: "Include Channel Preferences",
                  options: IncludeChannelPreferencesOptions,
                  inline: true,
                  span: fullWidth,
                },
                {
                  id: "field-AuditProfileChanges",
                  type: "radio",
                  name: "AuditProfileChanges",
                  label: "Audit Profile Changes",
                  options: [
                    { label: "Yes", value: 1 },
                    { label: "No", value: 0 },
                  ],
                  inline: true,
                  span: fullWidth,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
